import React, {useContext} from 'react'
import {Grid, Typography, Box} from '@material-ui/core'
import qrCode from '../../assets/images/qrcode.png'
import barcodeImg from '../../assets/images/barcode.png'
import barcodeText from '../../assets/images/barcode_text.png'
import aplogo from '../../assets/images/logo.png'
import {Draggable} from 'react-drag-and-drop'
import {Query} from 'react-apollo'
import {entitiesAllFields} from '../../graphql/barcode/queries/entitiesAllFieldsQuery'
import {companyLogo} from '../../graphql/barcode/queries/companyLogoQuery'
import LoadingScreen from '../BarcodeLoadingScreen'
import {useTranslation} from 'react-i18next'

import useStyles from './BarcodeLabelDragArea.styles'
import _ from 'lodash'
import {
  barcodenotext,
  barcodewithtext,
  qrcode,
  appLogo,
  fieldselect,
  companyLogoData,
} from './constants'
import {BarcodeLabelEditorContext} from '../../context/BarcodeLabelEditor'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings/BarcodeUserSettings'

function BarcodeLabelDragArea(props) {
  const {addItem} = useContext(BarcodeLabelEditorContext)
  const classes = useStyles()
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const {t} = useTranslation()

  function groupItemData(obj, fields) {
    let data = fieldselect
    data.fieldselect.item = {
      font_family: 'Arial',
      color: 'cf2d2d',
      ...obj,
    }
    data.fieldselect.fields = fields
    return data
  }

  function getCompanyLogo(url) {
    let logo = companyLogoData
    logo.companylogo.image =
      process.env.REACT_APP_CLOUDFRONT_URL + 'uploads' + url.split('uploads', 2)[1]
    return JSON.stringify(logo)
  }

  return (
    <React.Fragment>
      <Grid container className={classes.menuBar}>
        <Grid container item xs={12} justify="flex-start">
          <Typography className={classes.fontSize}>
            {t('barcode.label.drag-area.choose-one')}
          </Typography>
        </Grid>

        <Grid container item justify="flex-start" xs={4}>
          <Draggable
            type="dragitem"
            onClick={e => addItem({item: _.cloneDeep(qrcode)})}
            data={JSON.stringify(qrcode)}
            className={classes.dragItem + ' ' + classes.marginRight}
          >
            <img src={qrCode} alt="qrcode" className={classes.imageQRSize} />
          </Draggable>
        </Grid>

        <Grid container item justify="flex-start" xs={4}>
          <Draggable
            type="dragitem"
            onClick={e => addItem({item: _.cloneDeep(barcodenotext)})}
            data={JSON.stringify(barcodenotext)}
            className={classes.dragItem + ' ' + classes.imageBox}
          >
            <img src={barcodeImg} alt="barcode" className={classes.imageSize} />
          </Draggable>
        </Grid>

        <Grid container item justify="flex-start" xs={4}>
          <Draggable
            type="dragitem"
            onClick={e => addItem({item: _.cloneDeep(barcodewithtext)})}
            data={JSON.stringify(barcodewithtext)}
            className={classes.dragItem + ' ' + classes.marginLeft}
          >
            <img src={barcodeText} alt="barcode text" className={classes.imageSize} />
          </Draggable>
        </Grid>

        <Grid container item justify="flex-start" xs={4}>
          <Draggable
            type="dragitem"
            onClick={e => addItem({item: _.cloneDeep(appLogo)})}
            data={JSON.stringify(appLogo)}
            className={classes.dragItem + ' ' + classes.marginRight}
          >
            <img src={aplogo} alt="logo" className={classes.imageQRSize} />
          </Draggable>
        </Grid>

        <Query
          query={companyLogo}
          variables={{
            accountId: parseInt(userSettings.id),
            token: userSettings.token,
          }}
        >
          {({loading, error, data}) => {
            if (loading)
              return (
                <div>
                  <LoadingScreen size={50} />
                </div>
              )

            if (data && data.companyLogo.url)
              return (
                <Grid container item justify="flex-start" xs={4}>
                  <Draggable
                    type="dragitem"
                    onClick={e => addItem({item: JSON.parse(getCompanyLogo(data.companyLogo.url))})}
                    data={getCompanyLogo(data.companyLogo.url)}
                    className={classes.dragItem + ' ' + classes.marginRight}
                  >
                    <img
                      src={
                        process.env.REACT_APP_CLOUDFRONT_URL +
                        'uploads' +
                        data.companyLogo.url.split('uploads', 2)[1]
                      }
                      alt="companylogo"
                      className={classes.imageQRSize}
                    />
                  </Draggable>
                </Grid>
              )
            return null
          }}
        </Query>
      </Grid>
      <Grid container className={classes.menuBar}>
        <Grid container item xs={12} justify="flex-start">
          <Typography className={classes.fontSize}>
            {t('barcode.label.drag-area.add-field-from')}
          </Typography>
        </Grid>

        <Query
          query={entitiesAllFields}
          variables={{
            accountId: parseInt(userSettings.id),
            token: userSettings.token,
          }}
        >
          {({loading, error, data}) => {
            if (loading)
              return (
                <div>
                  <LoadingScreen size={50} />
                </div>
              )

            return (
              <React.Fragment>
                {data.entitiesAllFields.entities.map(obj => {
                  return (
                    <Grid container item xs={4} justify="flex-start" key={obj.id}>
                      <Draggable
                        type="dragitem"
                        onClick={e =>
                          addItem({
                            item: _.cloneDeep(
                              groupItemData(obj, data.entitiesAllFields.fields[obj.id])
                            ),
                          })
                        }
                        data={JSON.stringify(
                          groupItemData(obj, data.entitiesAllFields.fields[obj.id])
                        )}
                        className={classes.dragItem + ' ' + classes.marginRight}
                      >
                        <Box className={classes.textSize}>{obj.name}</Box>
                      </Draggable>
                    </Grid>
                  )
                })}
              </React.Fragment>
            )
          }}
        </Query>
      </Grid>
    </React.Fragment>
  )
}
export default BarcodeLabelDragArea
